<script setup>
import { ref } from "vue"
import { Swiper, SwiperSlide } from "swiper/vue"
import "swiper/css"
import "swiper/css/effect-coverflow"
import "swiper/css/navigation"
import { EffectCoverflow, Navigation } from "swiper/modules"

const swiperRef = ref(null)

function onSwiper(swiper) {
  swiperRef.value = swiper

  // after next tick (Swiper fully mounted)
  setTimeout(() => {
    const middle = Math.floor(swiper.slides.length / 2)
    swiper.slideTo(middle, 0) // go to middle instantly
  }, 0)
}
</script>

<template>
<main class="w-100"> <div class="hero-section-home" style="position: relative; height: 100vh; overflow: hidden;"> <img src="@/assets/images/homeLanding.png" alt="Skyreach" style="width: 100%; height: 100%; object-fit: cover;"> <!-- Overlay text kiri bawah --> <div style="position: absolute; bottom: 20px; left: 20px; color: white;"> <h1 style="font-weight: bold; text-transform: uppercase; font-size: 3rem; margin-bottom: 0.5rem;"> BEYOND CONNECTIVITY </h1> <p style="font-size: 1.25rem; margin: 0;"> Dari Indonesia Untuk Koneksi Tanpa Batas Ke Penjuru Dunia </p> </div> <!-- Signal kiri atas kecil --> <img src="@/assets/images/signal-icon.png" alt="Signal Kecil" class="signal-icon-small position-absolute" style="top: 25vh; left: 30vw; width: 5rem"> <!-- Signal kanan bawah besar --> <img src="@/assets/images/signal-icon.png" alt="Signal Besar" class="signal-icon-large position-absolute" style="bottom: 20vh; right: 35vw; width: 7rem;"> <!-- Signal kiri atas kecil --> <img src="@/assets/images/signal-icon.png" alt="Signal Kecil" class="signal-icon-small-2 position-absolute" style="top: 50vh; left: 9vw; width: 5rem"> </div> </main>

<!-- About Section -->
<section class="about-orange py-5">
  <div class="container">
    <p class="lead text-white mb-0">
      Skyreach, solusi komunikasi VSAT terdepan dari Indonesia, hadir untuk menghubungkan bisnis Anda secara global dengan konektivitas yang andal.
    </p>
  </div>
</section>




<!-- Highlight Solutions -->
<section class="py-5 bg-light">
  <div class="container">
    <h6 class="text-uppercase text-start mb-4">
      <i class="fas fa-circle me-2 text-orange"></i>
      <b class="text-blue">Highlight Solutions</b>
    </h6>
    <div class="row text-center">

      <!-- Connectivity -->
      <div class="col-md-4 mb-4">
        <div class="p-4 h-100">
          <div class="d-flex justify-content-center mb-3">
            <div class="rounded-circle d-flex align-items-center justify-content-center bg-primary bg-opacity-10" style="width:120px; height:120px;">
              <img src="@/assets/images/connectivity_icon.png" class="img-fluid" style="width:90px; height:90px;">
            </div>
          </div>
          <h5 class="fw-bold">CONNECTIVITY</h5>
          <p class="text-muted">
            Konektivitas VSAT yang andal dan mudah digunakan, menjamin komunikasi lebih mudah di mana pun Anda berada
          </p>
        </div>
      </div>

      <!-- Teleport -->
      <div class="col-md-4 mb-4">
        <div class="p-4 h-100 border-start border-end">
          <div class="d-flex justify-content-center mb-3">
            <div class="rounded-circle d-flex align-items-center justify-content-center bg-primary bg-opacity-10" style="width:120px; height:120px;">
              <img src="@/assets/images/teleport_icon.png" class="img-fluid" style="width:90px; height:90px;">
            </div>
          </div>
          <h5 class="fw-bold">TELEPORT & DATA CENTER</h5>
          <p class="text-muted">
            Infrastruktur <em>Teleport & Data Center</em> kami hadir sebagai pusat kendali sistem komunikasi dan manajemen data yang aman
          </p>
        </div>
      </div>

      <!-- IoT -->
      <div class="col-md-4 mb-4">
        <div class="p-4 h-100">
          <div class="d-flex justify-content-center mb-3">
            <div class="rounded-circle d-flex align-items-center justify-content-center bg-primary bg-opacity-10" style="width:120px; height:120px;">
              <img src="@/assets/images/iot_icon.png" class="img-fluid" style="width:90px; height:90px;">
            </div>
          </div>
          <h5 class="fw-bold">IoT SOLUTION</h5>
          <p class="text-muted">
            Solusi <em>IoT</em> kami membantu bisnis Anda mengumpulkan data real-time dan otomatisasi operasional untuk efisiensi maksimal
          </p>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- Industry Section -->
<section class="industry-section position-relative mb-5">
  <!-- Background image + text -->
  <div class="bg-image d-flex align-items-center justify-content-start p-4">
    <h2 class="text-white">Industry & Business Solution</h2>
  </div>

  <!-- Overlay di kanan (desktop) atau bawah (mobile) -->
  <div class="blue-overlay  d-flex align-items-center justify-content-center p-5" style="opacity: calc(0.8);">
    <div class="overlay-content">
      <p class="text-white">
        Manajemen operasional maritim lebih efektif dengan infrastruktur <i>ICT</i> 
        dan solusi <b>VSAT</b> yang terpadu.
      </p>
      <button data-bs-toggle="modal" data-bs-target="#Industry3" type="button" 
              class="btn btn-sm btn-outline-light me-2 text-uppercase italic-btn-outline" 
              style="border-radius: 0 !important;">
        More Industry & <b>Skyreach</b> Solution
      </button>
    </div>
  </div>
</section>



<section class="py-5 mb-5">
  <div class="container">
    <div class="row align-items-center">
      <!-- Left Column -->
      <div class="col-md-6">
        <h6 class="fw-bold text-blue mb-3">
          BISNIS ANDA ADALAH PRIORITAS KAMI...
        </h6>
        <p class="mb-3">
          Kami berkomitmen untuk senantiasa berkontribusi dalam mengatasi
          tantangan Teknologi Informasi dan Komunikasi dalam bisnis, terutama
          pada remote area.
        </p>
        <p class="mb-4">
          Komitmen ini terwujud melalui inovasi dan kemitraan jangka panjang,
          memastikan bahwa setiap solusi kami dapat mendorong pertumbuhan yang
          berkelanjutan bagi pelanggan dan ekosistem bisnis secara keseluruhan.
        </p>
        <a href="#"
          class="btn btn-warning btn-orange fw-bold text-uppercase px-4 py-2 rounded-0 italic-btn">
          Check Our Company Profile <i class="fas fa-arrow-right ms-2"></i>
        </a>
      </div>

      <!-- Right Column -->
      <div class="col-md-6 text-center">
        <img
          src="@/assets/images/bisnis_industry.png"
          alt="Skyreach Sailink"
          class="img-fluid rounded-3 my-5"
        />
      </div>
    </div>
  </div>
</section>


<!-- Swiper Highlight -->
<section class="highlight-section py-5 text-white">
  <div class="overlay"></div>
  <div class="container text-center position-relative">

    <h3 class="fw-bold mb-2">SKYREACH UPDATE & HIGHLIGHT</h3>
    <p class="mb-4">
      Temukan artikel dan berita terkini dari Skyreach seputar inovasi teknologi serta dampaknya pada bisnis Anda
    </p>

<Swiper
    :modules="[EffectCoverflow, Navigation]"
    effect="coverflow"
    grab-cursor="true"
    :centered-slides="true"
    :slides-per-view="'auto'"
    :loop="true"
    :coverflow-effect="{
      rotate: 0,
      stretch: -100,
      depth: 300,
      modifier: 2,
      slideShadows: false
    }"
    navigation
    class="mySwiper"
    @swiper="onSwiper"
  >
    <SwiperSlide>
      <img src="@/assets/images/card_3.png" class="card-slide" />
    </SwiperSlide>
    <SwiperSlide>
      <img src="@/assets/images/card_3.png" class="card-slide" />
    </SwiperSlide>
    <SwiperSlide>
      <img src="@/assets/images/card_3.png" class="card-slide" />
    </SwiperSlide>
    <SwiperSlide>
      <img src="@/assets/images/card_3.png" class="card-slide" />
    </SwiperSlide>
    <SwiperSlide>
      <img src="@/assets/images/card_3.png" class="card-slide" />
    </SwiperSlide>
        <SwiperSlide>
      <img src="@/assets/images/card_3.png" class="card-slide" />
    </SwiperSlide>
        <SwiperSlide>
      <img src="@/assets/images/card_3.png" class="card-slide" />
    </SwiperSlide>
  </Swiper>

    <h5 class="fw-bold mt-4">
      TEMUKAN <em>ICT SOLUTION</em> YANG INOVATIF DAN TEPAT UNTUK AKSELERASI BISNIS ANDA
    </h5>
  </div>
</section>
</template>

<style scoped>
.highlight-section {
  position: relative;
  background: url('@/assets/images/bg_home_product.png') center/cover no-repeat;
}
.highlight-section .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 24, 72, 0.7);
  z-index: 1;
}
.highlight-section .container {
  position: relative;
  z-index: 2;
}

.mySwiper {
  padding-top: 40px;
  padding-bottom: 60px;
}
.card-slide {
  width: 280px;
  border-radius: 16px;
  transition: transform 0.3s ease, opacity 0.3s ease;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

/* center big */
.swiper-slide-active .card-slide {
  transform: scale(1.1);
}
/* side smaller */
.swiper-slide-prev .card-slide,
.swiper-slide-next .card-slide {
  transform: scale(0.85);
  opacity: 0.8;
}

.swiper-slide{
  width: 80px !important;
}


.mySwiper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mySwiper .swiper-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.mySwiper .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 280px; /* atur sesuai card kamu */
}
</style>
